import React from "react";

const WhyChooseMe = () => {
  return (
    <div className="container mt-50px pt-5 mb-5">
      <h2 className="text-white fs-1 text-md-center">WHY PEOPLE CHOOSE ME</h2>
      <p className="text-white fs-4 text-md-center">
        Our sport experts and latest sports equipment are the winning
        combination.
      </p>
      <div className="row mt-5">
        <div className="col-md-6 col-lg-4 mt-4">
          <h3 style={{ color: "#f36100" }} className="fs-2 text-md-center">
            SUPPORT 24/7
          </h3>
          <p className="text-light fs-4 text-md-center">
            One of the best ways to make a great vacation quickly horrible is to
            choose the wrong accommodations for your trip.
          </p>
        </div>
        <div className="col-md-6 col-lg-4 mt-4">
          <h3 style={{ color: "#f36100" }} className="fs-2 text-md-center">
            TRAINER
          </h3>
          <p className="text-light fs-4 text-md-center">
            If you are an infrequent traveler you may need some tips to keep the
            wife happy while you are jet setting around the globe.
          </p>
        </div>
        <div className="col-md-6 col-lg-4 mt-4">
          <h3 style={{ color: "#f36100" }} className="fs-2 text-md-center">
            PERSONALIZED SESSIONS
          </h3>
          <p className="text-light fs-4 text-md-center">
            To succeed at any endeavor, you must stay the course…no matter what
            the cost! Here are some surefire tips to help you on your journey.
          </p>
        </div>
        <div className="col-md-6 col-lg-4 mt-4">
          <h3 style={{ color: "#f36100" }} className="fs-2 text-md-center">
            EQUIPMENT
          </h3>
          <p className="text-light fs-4 text-md-center">
            Rugby and Stratford-upon-Avon. Additionally, there are many things
            to see and do in and around Coventry itself.
          </p>
        </div>
        <div className="col-md-6 col-lg-4 mt-4">
          <h3 style={{ color: "#f36100" }} className="fs-2 text-md-center">
            CLASSES DAILY
          </h3>
          <p className="text-light fs-4 text-md-center">
            We would just not have the will in us to go about our daily lives.
            Its motivation that helps us get through the most mundane.
          </p>
        </div>
        <div className="col-md-6 col-lg-4 mt-4">
          <h3 style={{ color: "#f36100" }} className="fs-2 text-md-center">
            FOCUS ON YOUR HEALTH
          </h3>
          <p className="text-light fs-4 text-md-center">
            But there is only so far we can go within the constraints of a
            family budget in building the perfect telescopic operation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseMe;
